import { createSlice } from '@reduxjs/toolkit'
import Errors from 'src/modules/shared/error/errors'
import { LoggedInUser } from 'src/modules/shared/Types'

export interface AuthState {
  loggedInUser: LoggedInUser | null
  loading: false
}
const initialState: AuthState = {
  loggedInUser: null,
  loading: false,
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: initialState,
  reducers: {
    authInitSuccess: (state, action) => {
      state.loggedInUser = { user: action.payload.user }
    },
    authInitError: (state, action) => {
      state.loggedInUser = null
    },
    signOutSuccess: (state, action) => {
      state.loggedInUser = null
    },
  },
})

export const authThunkActions = {
  init: () => async (dispatch, getState) => {
    try {
      // const user = new FirebaseAuthenticationService().getCurrentUser()
      // if (user) {
        // dispatch(authSlice.actions.authInitSuccess({ user: user }))
        dispatch(authSlice.actions.authInitSuccess({ user: null }))
      // } else {
      //   dispatch(authSlice.actions.authInitError({}))
      // }
    } catch (error: any) {
      Errors.handle(error)
      dispatch(
        authSlice.actions.authInitError({ error: `Error when trying to get a logged in user. ${error.message}` })
      )
    }
  },

  signOut: () => async (dispatch, getState) => {
    // try {
    //   await new FirebaseAuthenticationService().signOut()
    //   dispatch(authSlice.actions.signOutSuccess({}))
    // } catch (error: any) {
    //   Errors.handle(error)
    //   dispatch(authSlice.actions.authInitError({ error: `Error when trying to sign out. ${error.message}` }))
    // }
  },
}

export default authSlice
